import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Go back in in-app history when there is an in-app back stack
 * (react-router sets history.state.idx on each entry); otherwise
 * navigate to the home route. Fixes deep links opened from push
 * notifications where the browser history stack is empty and
 * navigate(-1) would do nothing.
 */
export function useSmartBack(fallback = '/') {
  const navigate = useNavigate();
  return useCallback(() => {
    const idx = (window.history.state as { idx?: number } | null)?.idx;
    if (typeof idx === 'number' && idx > 0) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  }, [navigate, fallback]);
}
